<h4 class="bucket-header">Email settings</h4>

<p class="small-300 mt-2">
  Customize the content and recipients of the statement based on the age of the oldest outstanding invoice for the
  {{ recipientLabel$ | async }}.
  <br />
  An * indicates you have customized the values for the respective bucket.
</p>

<mat-tab-group class="tab-bar mt-4" [fitInkBarToContent]="true" [mat-stretch-tabs]="false">
  <mat-tab *ngFor="let display of bucketDisplays$ | async; trackBy: identify">
    <ng-template mat-tab-label>
      {{ display.bucket.name }}

      @let form = display.form;

      @let subjectForm = form.controls.subject;
      @let headerForm = form.controls.header;
      @let bodyForm = form.controls.body;

      <!-- Error within the form -->
      <ng-container
        *ngIf="
          (form.touched || form.dirty) && (form.invalid || subjectForm.invalid || headerForm.invalid || bodyForm.invalid);
          else overrideCheck
        "
      >
        <anduin-icon name="alert-triangle" class="alert-icon ms-1" />
      </ng-container>

      <ng-template #overrideCheck>
        {{
          (display.hasCustomOverride$ | async) && display.bucket.smartStatementBucket !== SmartStatementBucket.ZERO_TO_THIRTY ? ' *' : ''
        }}
      </ng-template>
    </ng-template>

    <ng-template matTabContent>
      <app-input-with-variable
        #subjectInput
        class="mt-6"
        [formControl]="$any(display?.form.controls.subject)"
        [placeholder]="display.subjectPlaceholder$ | async"
        [variables]="messageVariables"
        inputType="input"
        label="Subject"
      />
      <mat-error
        *ngIf="
          display?.form?.controls?.subject?.errors && (display?.form?.controls?.subject?.touched || display?.form?.controls?.subject?.dirty)
        "
      >
        Subject is required.
      </mat-error>
      <div class="mt-6">
        <label class="mb-2 rich-text-editor-label">Headline</label>
        <app-template-rich-text-editor
          id="header-rich-text-editor"
          [control]="$any(display?.form?.controls?.header)"
          [placeholder]="display.headerPlaceholder$ | async"
        />
        <p class="small-400">Appears at the top of the statement email message body.</p>
      </div>

      <mat-error
        *ngIf="display?.form.controls.header?.errors && (display?.form.controls.header.touched || display?.form.controls.header.dirty)"
      >
        Headline is required.
      </mat-error>

      <div class="mt-6">
        <label class="mb-2 rich-text-editor-label">Message</label>
        <app-template-rich-text-editor
          id="body-rich-text-editor"
          [control]="$any(display?.form?.controls?.body)"
          [placeholder]="display.bodyPlaceholder$ | async"
        />
        <p class="small-400">The message appears near the top of the statement email body.</p>
      </div>

      <mat-error *ngIf="display?.form.controls.body?.errors && (display?.form.controls.body.touched || display?.form.controls.body.dirty)">
        Message body is required.
      </mat-error>
    </ng-template>
  </mat-tab>
</mat-tab-group>
